import { cancel, put, select, takeLatest } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedActions,
  paginatedConsts as communitiesJoinRequests,
} from '../communitiesJoinRequests';
import {
  selectActivityListByType,
  selectActivityMetaByType,
} from '../selectors/activitiesSelector';

function* joinRequestsPaginationWorker(action) {
  const { payload } = action;
  const { limit, type } = payload;

  const currentList = yield select(selectActivityListByType(type));
  const { total, ...paginationOptions } = yield select(
    selectActivityMetaByType(type),
  );

  if (total <= currentList.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    offset: currentList.length,
    limit,
    type,
  });

  yield put(paginatedActions.updatePaginationParameters(params));
  yield put(paginatedActions.send(params));
}

export default function* joinRequestsPaginationSaga() {
  yield takeLatest(
    communitiesJoinRequests.LOAD_NEXT_REQUESTS,
    joinRequestsPaginationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/joinRequestListPagination.js